<template>
    <div>
      <table class="custom-table responsive-table border-collapse">
        <thead class="font-normal">
          <tr class="shadow-table rounded-lg opacity-50">
            <th>PERIOD</th>
            <th>SALES (EXCL. TAX)</th>
            <th>TAX</th>
            <th>SALES (INCL. TAX)</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="rounded-lg bg-white"
            v-for="i in [1, 2, 3, 4, 5, 6, 7]"
            :key="i"
          >
            <td>March</td>
            <td>N142,000</td>
            <td>N10,000</td>
            <td>N132,000</td>
            <td>
              <span
              @click="shoeEditdata = true"
              class=" text-primary-green w-full flex justify-end items-center cursor-pointer">
                <img src="@/assets/images/icons/edit-box.svg" class="mr-1"/>
                Edit</span></td>
          </tr>
        </tbody>
      </table>
  
      <PaginationControl
        :total="totalCollection"
        :pageNumber="sortOptions.pageNumber"
        @pageNumber="setPageDisplayCollection"
        @pageSize="setNumDisplayCollection"
      />
      <EditSalesdata :show-modal="shoeEditdata"
      @close-modal="shoeEditdata = false"/>

      <!-- <EmptyContent v-if="!bookings.length" /> -->
    </div>
  </template>
  
  <script>
  //   import EmptyContent from "../UI/EmptyContent.vue";
  import PaginationControl from "@/components/UI/pagination";
  import EditSalesdata from "../modals/EditSalesdata.vue";
  
  export default {
    props: ["bookings"],
    components: { PaginationControl, EditSalesdata },
    data() {
      return {
        shoeEditdata: false,
        showFilterModal: false,
        collectPaymentModal: false,
        selectedRowId: -1,
        shareLinkModal: false,
        totalCost: 0,
        transactionId: null,
        shippingId: "",
        paylink: "",
        email: "",
        payAmount: "",
        sortOptions: {
          pageSize: 10,
          pageNumber: 1,
          startDate: null,
          endDate: null,
          searchString: "",
        },
      };
    },
    computed: {
      paymentParams() {
        return {
          paylink: this.paylink,
          email: this.email,
          payAmount: this.payAmount,
        };
      },
    },
    methods: {
      setNumDisplayCollection(val) {
        this.sortOptions = { ...this.sortOptions, pageSize: val };
      },
      setPageDisplayCollection(val) {
        this.sortOptions = { ...this.sortOptions, pageNumber: val };
      },
      sortItemProps(val) {
        this.sortOptions = { ...this.sortOptions, ...val };
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .actions {
    @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
    min-width: 200px;
  }
  .actions div {
    @apply flex w-full py-2 px-2 items-center;
  }
  .icon {
    width: auto;
    padding-right: 5px;
  }
  th {
    font-weight: 300;
  }
  </style>
  